import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseCRUDApiClient } from '@do/app-base-components';
import { PermissionDto } from '@do/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable({ providedIn: 'root' })
export class PermissionApiClient extends BaseCRUDApiClient<PermissionDto> {
  baseUrl = this.config.apiEndpoint + '/permission';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
